import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="facility-edit"
export default class extends Controller {
  static targets = ["saveButton"];

  connect() {
    // Initial validation check
    this.validateForm();
  }

  facilityFieldChanged() {
    this.validateForm();
  }

  validateForm() {
    // Get product IDs from the sector-products controller
    const productIdsField = document.querySelector(
      '[data-sector-products-target="productIdsField"]'
    );
    const productIds = productIdsField ? productIdsField.value.trim() : "";

    // Check if all required fields are filled
    const isValid = productIds;

    // Enable/disable save button
    this.saveButtonTarget.disabled = !isValid;

    if (isValid) {
      this.saveButtonTarget.classList.remove(
        "opacity-50",
        "cursor-not-allowed"
      );
      this.saveButtonTarget.removeAttribute("disabled");
    } else {
      this.saveButtonTarget.classList.add("opacity-50", "cursor-not-allowed");
      this.saveButtonTarget.setAttribute("disabled", "disabled");
    }
  }
}
